import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
// import { registerServiceWorker } from '../registerServiceWorker';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

// Day.js global konfigurieren
import './app/_utils/dayjs.config';

if (environment.production) {
  enableProdMode();
  // registerServiceWorker();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.log(err));
